export default __webpack_public_path__ + "static/media/placeholder_portfolio04-it-web.5f811bc1.png";